import apiService from '@/services/apiService';

const actions = {
  getCorpSalesExcellences({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('corporate-sales/excellence/find-with-paging', payload)
        .then((response) => {
          commit('getCorpSalesExcellences', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCorpSalesExcellence({ commit }, payload) {
    apiService.get(`corporate-sales/excellence/${payload}`)
      .then((response) => {
        commit('getCorpSalesExcellence', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  orderCorpSalesExcellence({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`corporate-sales/excellence/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postCorpSalesExcellence({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('corporate-sales/excellence', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateStatusCorpSalesExcellence({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('corporate-sales/excellence/update-status', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putCorpSalesExcellence({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`corporate-sales/excellence/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delCorpSalesExcellence({ commit }, payload) {
    apiService.delete(`corporate-sales/excellence/${payload}`)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
